<template>
  <div class="section grid-view">
    <div class="main-content">
      <div class="operations" style="margin-bottom: 5px">
        <div class="triggers">
          <div>
            <el-button no="query" :disabled="!isEdit" type="primary" @click="toQuery">{{ $t('common.btn.query') }}</el-button>
            <el-button no="upload" :disabled="!isEdit" type="primary" @click="cloudFile.visible=true">{{ $t('FileHistory.Upload') }}</el-button>
            <el-button no="delete" :disabled="!isEdit" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
            <el-button no="invoiceDownloadLabel" :disabled="!isEdit" type="primary" @click="download">{{ $t('Invoice.invoice_invoiceDownloadLabel') }}</el-button>
          </div>
        </div>
      </div>
      <div class="grid-wrapper">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="flex-grow:1;height:100%;width:100%"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
      <!-- 云文件上传对话框 -->
      <cargo-cloud-file-upload
        :visible.sync="cloudFile.visible"
        :job="cloudFile.job"
        :lob="cloudFile.lob"
        @uploadDone="toQuery"
      />
      <drop-uploader
        v-if="isEdit"
        ref="dropUploader"
        :action="URL.common.uploadStorage"
        :upload-params="uploadParams"
        @upload-end="uploadEnd"
      />
    </div>
    <!-- 预览文件弹窗 -->
    <pre-view-file-dialog
      :v-if="previewFileData.visible"
      no="preview"
      :title="$t('FileHistory.preview')"
      :visible="previewFileData.visible"
      :file="previewFileData.file"
      :can-maximize="true"
      @close="closePreviewDialog"
    />
  </div>
</template>

<script>
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import URL from '@/api/urlTranslator'
import { getDocCategoryTypeTreeByLob } from '@/api/sysManage/baseConfig/docCategory'
import { Company } from '@/class/model/mdm/Company'
import { getFileList, deleteFile } from '@/api/storage'
import { cacheName, cache } from '@/utils/cacheManager'
import { DocumentManage } from '@/utils/commonUtil'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import pdf from 'vue-pdf'
import preViewFileDialog from '@/components/Cargo/Common/preViewFileCommonDialog'

export default {
  name: 'DocumentForm',
  components: { cargoCloudFileUpload, DropUploader, CargoDialog, pdf, preViewFileDialog },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    const isZh = this.$i18n.locale === 'zh'
    return {
      URL,
      isZh,
      user: {},
      storageURL: '',
      fileTypeMap: new Map(),
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('FileHistory.fileName'),
          field: 'fileName',
          width: 200
        },
        {
          headerName: this.$t('FileHistory.jobType'),
          field: 'fileType',
          width: 90,
          cellRenderer: params => {
            return this.fileTypeMap.get(params.value.toUpperCase()) || this.$t('Message.Other')
          }
        },
        {
          headerName: this.$t('FileHistory.fileType'),
          field: 'fileFormat',
          width: 200
        },
        {
          headerName: this.$t('FileHistory.fileSize'),
          field: 'fileSize',
          width: 90,
          cellRenderer: params => {
            return params.value ? (params.value / 1024).toFixed(2) + 'KB' : ''
          }
        },
        {
          headerName: this.$t('FileHistory.view'),
          field: 'fileId',
          suppressMenu: true,
          width: 200,
          cellRenderer: params => {
            let preview = ''
            const fileStr = params.data.fileName
            const location = fileStr.lastIndexOf('.')
            const type = fileStr.substring(location + 1, fileStr.length)
            if (type === 'jpg' || type === 'png' || type === 'jpeg' || type === 'gif' || type === 'webp' || type === 'pdf' ||
              type === 'doc' || type === 'docx' || type === 'xls' || type === 'xlsx') {
              const handlePreviewFile = this.documentManage.getPath('handlePreviewFile')
              preview = `<a onclick="${handlePreviewFile}('${params.value}')" style="color:blue">${this.$t('FileHistory.preview')}</a>`
            }
            return `<a href="${URL.common.findByFileId}/${params.value}?sessionId=${this.$store.getters.userInfo.sessionId}" target="_blank" style="color:blue">
                    ${this.$t('Partners.viewFile')}
                    </a>` + preview
          }
        }
      ],
      rowData: [],
      gridApi: null,
      cloudFile: {
        visible: false,
        job: new Company(),
        lob: 'PT'
      },
      // 图片预览参数
      previewFileData: {
        visible: false,
        file: null
      },
      documentManage: new DocumentManage()
    }
  },
  computed: {
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    },
    uploadParams() {
      const params = {}
      params.companyKey = this.cloudFile.job.uuid
      params.uuid = this.cloudFile.job.uuid
      if (this.cloudFile.job.hasOwnProperty('documentType')) {
        params.documentType = this.cloudFile.job.documentType
      } else {
        params.documentType = 'other'
      }
      params.createdBy = this.user.userId
      params.createChineseName = this.user.chineseName
      params.createEnglishName = this.user.englishName
      params.documentName = 'other'
      params.isShared = false
      params.op = false
      params.sales = false
      params.all = false
      params.customer = false
      params.consignee = false
      params.shipper = false
      params.destinationAgent = false
      params.bookingAgent = false
      return params
    }
  },
  async created() {
    getDocCategoryTypeTreeByLob({ constructLobParent: false, lob: this.cloudFile.lob }).then(res => {
      res.data.forEach(item => {
        if (item.type === 2) {
          this.fileTypeMap.set(item.code.toUpperCase(), this.isZh ? item.chineseName : item.englishName)
        }
      })
    })
    await cache.load(cacheName.USER, cacheName.CONFIG)
    this.user = cache.user
  },
  beforeMount() {
    const context = this
    this.documentManage.set('handlePreviewFile', function(value) {
      context.handlePreviewFile(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    onShow(row, isRefresh) {
      if (isRefresh) {
        this.cloudFile.job = new Company(row)
        this.toQuery()
      }
    },
    async toQuery() {
      this.storageURL = cache.config.get('StorageURL')
      const xmlParam = '<RequestObject><data><extendMetaData><entry><key>companyKey</key><value>' +
        this.cloudFile.job.uuid +
        '</value></entry></extendMetaData></data></RequestObject>'
      await getFileList(xmlParam).then(res => {
        this.rowData = Array.from(res.data, p => {
          return {
            fileId: p.id,
            fileName: p.fileName,
            fileType: p.extendMetaData.documentType || '',
            fileFormat: p.fileType.split(';')[0],
            fileSize: p.fileSize
          }
        })
      })
    },
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        try {
          for (const item of rows) {
            const isSuccess = await deleteFile(item.fileId).then(res => res.data === 'success')
            if (isSuccess) {
              item.isDeleted = true
              this.$message.success(this.$t('Partners.fileDeletedSuccessfully'))
            } else {
              break
            }
          }
        } finally {
          this.rowData = this.rowData.filter(p => !p.isDeleted)
        }
      }).catch(() => { })
    },
    download() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (rows.length === 1) {
        window.open(`${URL.common.findByFileId}/${rows[0].fileId}?sessionId=${this.$store.getters.userInfo.sessionId}`)
      } else {
        const fileIds = Array.from(rows, p => p.fileId).reduce((a, b) => a + ',' + b)
        const fileName = this.cloudFile.job.shortName + '.zip'
        window.open(`${URL.common.compressFiles}?sessionId=${this.$store.getters.userInfo.sessionId}&fileIds=${fileIds}&fileName=${fileName}`)
      }
    },
    async handlePreviewFile(value) {
      const fileObject = this.rowData.find(x => x.fileId === value)
      this.previewFileData.file = fileObject
      this.previewFileData.visible = true
    },
    // 处理文件后缀名
    getFileType(fileName) {
      const arr = fileName.split('.')
      if (arr.length > 1) {
        return arr[arr.length - 1].toLowerCase()
      }
      return ''
    },
    closePreviewDialog() {
      this.previewFileData.file = null
      this.previewFileData.visible = false
    },
    uploadEnd() {
      this.toQuery()
    }
  }
}
</script>

<style scoped lang="scss">
.grid-view {
  &.section {
    padding: 10px 20px;
  }
}
.preview-img{
  height: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img{
    width: auto;
    max-width: 100%;
    min-width: 120px;
    min-height: 120px;
    height: auto;
  }
}
.pdf-img{
  height: 450px;
  .el-scrollbar{
    height: 450px;
    /deep/ .el-scrollbar__wrap{
      overflow-x: hidden;
    }
    /deep/ .el-scrollbar__bar{
        opacity: 1;
    }
  }
}
.office-preview {
  width: 100%;
  height: 100%;
  min-height: 600px;
  border: none;
}
.tab-file-history ::v-deep {
  .preview-dialog.is-fullscreen {
    height: 100%;
    .el-dialog__body {
      height: 100%;
      .pdf-img{
        height: 100%;
        .el-scrollbar{
          height: 100%;
        }
      }
    }
  }
}
</style>
